export { default as DatabaseOutlineIcon } from './DatabaseOutlineIcon';
